import { useEffect, useRef, useState } from "react";
import { PopupModal, useCalendlyEventListener } from "react-calendly";
import mixpanel from "mixpanel-browser";
import { Urls } from "../../Urls";

const track = (moduleName, definition, userData = {}) => {
  if (!moduleName) return;
  mixpanel.track(definition, {
    ApplicationName: Urls.mixpanelappname,
    ScreenName: "LoRRI Screen Zero / Calendly",
    ModuleName: moduleName,
    ...userData,
  });
};

const CalendlyPopupButton = ({
  url,
  text = "Express interest →",
  className,
  onClick,
  triggerPopup = false,
  open: openProp,
  style,
  moduleName,
  prefill = {},
  onClose,
  onCalendlyOpen,
  onCalendlyDateSelected,
  onCalendlyScheduled,
  onCalendlyDropOff,
  userData = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasScheduled = useRef(false);

  useEffect(() => {
    if (openProp !== undefined) setIsOpen(openProp);
  }, [openProp]);

  useCalendlyEventListener({
    onEventTypeViewed: () => {
      if (isOpen) {
        hasScheduled.current = false;
        track(moduleName, "Calendly modal opened", userData);
        onCalendlyOpen?.();
      }
    },
    onDateAndTimeSelected: () => {
      if (isOpen) {
        track(moduleName, "Calendly date selected", userData);
        onCalendlyDateSelected?.();
      }
    },
    onEventScheduled: (e) => {
      if (isOpen) {
        hasScheduled.current = true;
        track(moduleName, "Calendly meeting scheduled", userData);
        onCalendlyScheduled?.(e);
      }
    },
  });

  const handleClick = (e) => {
    onClick?.(e);
    if (triggerPopup) setIsOpen(true);
  };

  const handleModalClose = () => {
    if (!hasScheduled.current) {
      track(moduleName, "Calendly modal closed without booking", userData);
      onCalendlyDropOff?.();
    }
    hasScheduled.current = false;
    setIsOpen(false);
    onClose?.();
  };

  return (
    <>
      {triggerPopup && (
        <button className={className} onClick={handleClick} style={style}>
          {text}
        </button>
      )}
      <PopupModal
        url={url}
        onModalClose={handleModalClose}
        open={isOpen}
        rootElement={document.getElementById("root") || document.body}
        prefill={prefill}
      />
    </>
  );
};

export default CalendlyPopupButton;
